import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

// users
import User from "./Users/reducer"

// permissions
import Permission from "./Permissions/reducer"

// roles
import Role from "./Roles/reducer"

// Customers
import Customer from "./Customers/reducer";

// Levels
import Level from "./Levels/reducer"

// rewards
import Reward from "./Rewards/reducer"

// courses
import Course from "./Courses/reducer"

// modules
import Module from "./Modules/reducer"

// chapters
import Chapter from "./chapters/reducer"

// students
import Student from "./Students/reducer"

// tutors
import Tutor from "./Tutors/reducer"

//lessons
import Lesson from "./lessons/reducer"

//attendance
import Attendance from './attendance/reducer'

//assignment
import Assignment from './assignment/reducer'

import QuestionsAndAnswers from "./questionAndAnswers/reducer"





const rootReducer = combineReducers({
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  User,
  Customer,
  Permission,
  Role,
  Level,
  Reward,
  Course,
  Module,
  Chapter,
  Student,
  Tutor,
  Lesson ,
  Attendance ,
  Assignment,
  QuestionsAndAnswers
  
})

export default rootReducer;
